export function titleFromSlug(slug) {
  const s = String(slug || '')
    .trim()
    .toLowerCase()
  if (!s) return 'Connection'
  return s.replace(/[-_]+/g, ' ').replace(/\b\w/g, (m) => m.toUpperCase())
}
